<div class="p-4">
    <div class="container">
        <h1>Hi {{user.firstName}}!</h1>
        <p>Chào Mừng Đến Trang Quản Lí</p>
        <p><button class="btn btn-warning" routerLinkActive="active" routerLink="/landingpagemanage">Quản Lí LandingPage</button></p>
    </div>
</div>